import React, { useState } from 'react';
import { useField } from 'formik';
import styled from 'styled-components/macro';

const Container = styled.div<{ width?: string; isError: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ width }) => (width ? width : '100%')};
  border: 1px solid ${({ isError }) => (isError ? 'red' : '#e3e5e8')};
  position: relative;
  margin: 3px 0;
`;

const Ul = styled.ul`
  position: absolute;
  background: white;
  padding: 0;
  margin: 0;
  top: 1.5rem;
  left: 0;
  z-index: 2;
  width: 100%;
  border: 1px solid #e3e5e8;
  display: flex;
  flex-direction: column;
  list-style-type: none;
  align-items: flex-start;
`;

const Li = styled.li`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 2px 5px;

  &:hover {
    background-color: grey;
    color: white;
  }
`;

const Shadow = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: transparent;
  top: 0;
  left: 0;
`;

const Selected = styled.p`
  margin:0;
  padding 0.2rem 0.5rem;
  width: 100%;
`;

const Select = ({
  field: { name, value },
  form: { setFieldValue },
  options,
  width,
  placeholder = 'Select',
}: any) => {
  const [_field, meta] = useField(name); // eslint-disable-line
  const { touched, error } = meta;
  const isError = touched && typeof error === 'string';

  const [isOpen, setIsOpen] = useState(false);

  const changeValue = (value: string) => {
    setFieldValue(name, value);
    setIsOpen(false);
  };

  const findName = (newValue: string) => {
    const selected = options.find(({ value }: any) => value === newValue);

    return selected ? selected.name : placeholder;
  };

  return (
    <Container width={width} isError={isError}>
      <Selected onClick={() => setIsOpen(!isOpen)}>
        {value ? findName(value) : placeholder}
      </Selected>
      {isOpen && <Shadow onClick={() => setIsOpen(false)} />}
      {isOpen && (
        <Ul>
          {options.map(({ name, value }: { name: string; value: string }) => {
            return (
              <Li key={value} onClick={() => changeValue(value)}>
                {name}
              </Li>
            );
          })}
        </Ul>
      )}
    </Container>
  );
};

export default Select;
